import PartTypes from "../tabs/part-types";
import { Drawer } from "antd";
import layoutStorage from "../../../storages/layout-storage";
import { observer } from 'mobx-react-lite';

interface IPartTypesDialogProps {
  onClose: () => void;
}

function PartTypesDialog(props: IPartTypesDialogProps) {
  const {
    isAddPartTypeModalOpened,
    toggleAddPartTypeModalDialog,
  } = layoutStorage;

  function onClose() {
    toggleAddPartTypeModalDialog();
    props.onClose();
  }

  return (
    <Drawer
      title="Add part type"
      width={520}
      closable={true}
      onClose={onClose}
      open={isAddPartTypeModalOpened}
    >
      <PartTypes />
    </Drawer>
  );
}

export default observer(PartTypesDialog);
